// :cow: Cosmose CONFIDENTIAL :iso:
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { StoreModule } from '@ngrx/store';
import { metaReducers } from './core/store/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@coa/environments/environment';
import { DefaultRouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthInterceptor } from '@coa/app/core/interceptors/auth.interceptor';
import { ChartjsExtensionService } from '@coa/app/shared/chart-js/chartjs-extension.service';
import { PreviousUrlService } from '@coa/app/libs/services/previous-url.service';
import { authReducer } from '@coa/app/auth/store/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from '@coa/app/auth/store/auth.effects';
import { AUTH_SERVICE_PROVIDER } from '@coa/app/shared/auth-service-provider/auth-service-provider';
import { UnauthorizedInterceptor } from '@coa/app/core/interceptors/unauthorized.interceptor';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
    HttpClientModule,
    MatSnackBarModule,
    StoreModule.forRoot({
      auth: authReducer,
    }, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
      metaReducers,
    }),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    EffectsModule.forRoot([AuthEffects]),
    StoreRouterConnectingModule.forRoot({serializer: DefaultRouterStateSerializer}),
    NgxSpinnerModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true},
    ChartjsExtensionService,
    PreviousUrlService,
    AUTH_SERVICE_PROVIDER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
